// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isOfferfitAppGroupIdUseCasesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      offerfit_client: string,
      offerfit_pipeline: string,
      offerfit_usecase: string,
      usecase_display_name: string,
      // Keep in sync with the backend status union (OfferfitController#derive_agent_status).
      status: enumOf("live", "stopped", "draft"),
      // Second arg allows explicit JSON null, so an unresolved DSA tier
      // degrades gracefully instead of failing response validation.
      tier: maybe(string, true),
      last_edited_by: maybe(string, true),
      last_edited_by_product: maybe(string, true),
    })
  ),
});
